import React from 'react';
import { LeadForm } from '../LeadForm/LeadForm';
import { viewingContent } from './Viewing.content';
import birds from './assets/birds.webp';
import styles from './Viewing.module.sass';

import cloud from './assets/cloud-1.webp';
import cloud3 from './assets/cloud-2.webp';

export function Viewing() {
  const {
    title,
    subtitle,
    phoneDisplay,
    phoneTel,
    formIntro,
    phoneLabel,
    phonePlaceholder,
    nameLabel,
    submitLabel,
    consentLabel,
    disclaimer,
  } = viewingContent;

  return (
    <section className={styles.viewing} id="contacts">
      <img src={birds} alt="" className={styles.viewing__birds} aria-hidden />

      <div className={styles.viewing__inner}>
        <div className={styles.viewing__left}>
          <h2 className={styles.viewing__title}>
            {title.map((seg, i) => (
              <React.Fragment key={i}>
                {seg.accent ? (
                  <span
                    className={styles.viewing__titleLineAccent}
                    dangerouslySetInnerHTML={{ __html: seg.text }}
                  />
                ) : (
                  <span
                    className={styles.viewing__titleLine}
                    dangerouslySetInnerHTML={{ __html: seg.text }}
                  />
                )}
              </React.Fragment>
            ))}
          </h2>
          <p className={styles.viewing__subtitle}>
            {subtitle.map((seg, i) => (
              <React.Fragment key={i}>
                {seg.accent ? (
                  <span
                    className={styles.viewing__subtitleLineAccent}
                    dangerouslySetInnerHTML={{ __html: seg.text }}
                  />
                ) : (
                  <span
                    className={styles.viewing__subtitleLine}
                    dangerouslySetInnerHTML={{ __html: seg.text }}
                  />
                )}
              </React.Fragment>
            ))}
          </p>
          <a className={styles.viewing__phone} href={`tel:${phoneTel}`}>
            {phoneDisplay}
          </a>
        </div>

        <div className={styles.viewing__right}>
          <div className={styles.viewing__formIntro}>
            {formIntro.map((seg, i) => (
              <React.Fragment key={i}>
                {seg.accent ? (
                  <span
                    className={styles.viewing__formIntroLineAccent}
                    dangerouslySetInnerHTML={{ __html: seg.text }}
                  />
                ) : (
                  <span
                    className={styles.viewing__formIntroLine}
                    dangerouslySetInnerHTML={{ __html: seg.text }}
                  />
                )}
              </React.Fragment>
            ))}
          </div>

          <LeadForm
            variant="viewing"
            phoneLabel={phoneLabel}
            phonePlaceholder={phonePlaceholder}
            nameLabel={nameLabel}
            submitLabel={submitLabel}
            consentLabel={consentLabel}
            disclaimer={disclaimer}
          />
        </div>
      </div>
      <img  src={cloud} alt="Облако" className={styles['viewing__cloud-1']} />
      <img  src={cloud3} alt="Облако" className={styles['viewing__cloud-2']} />
    </section>
  );
}
